import Alert from '@/utils/components/alert';

/**
 * Common error handler for transaction errors
 * Handles user rejection, insufficient funds, and other transaction errors
 */
export function handleTransactionError(e: any) {
    if (e) {
        let errorMessage = e.message;

        // Check if user cancelled/rejected the transaction
        if (
            e.code === 4001 ||
            e.code === 'ACTION_REJECTED' ||
            (typeof errorMessage === 'string' &&
                (errorMessage.toLowerCase().includes('user rejected') ||
                    errorMessage.toLowerCase().includes('user denied') ||
                    errorMessage.toLowerCase().includes('user cancelled')))
        ) {
            errorMessage = 'User denied transaction signature';
        } else if (e.code === 10042) {
            errorMessage = 'Insufficient funds';
        }

        // Silent return for code 1000
        if (e.code === 1000) {
            return;
        }

        Alert({
            type: 'error',
            text: errorMessage || 'Something wrong, please try again later',
        });
    }
}

// Alias for backward compatibility
export const handleError = handleTransactionError;
